import { createSelector } from '@reduxjs/toolkit'
import { IRegister } from './reducer'

const rootState = (state: IRegister) => state.register

export const getActiveStep = createSelector(
  rootState,
  (state) => state.activeStep
)
